import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { SVGIcon } from '@progress/kendo-svg-icons';
import clsx from 'clsx';
import {
    Layout1MapOutline,
    Layout2MapsHorizontalOutline,
    Layout2MapsVerticalOutline,
    Layout3MapsBottomSplitOutline,
    Layout3MapsRightSplitOutline,
    Layout4MapsOutline
} from '../../../../../icons/icons';
import { WorkspaceLayout } from '../../../../../types/settings';
import CustomPopover from '../../../../components/layout/CustomPopover';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setWorkspaceLayout } from '../../../../state/slices/workspace-slice';

const workspaceLayoutToIconMap: Record<WorkspaceLayout, SVGIcon> = {
    [WorkspaceLayout.single]: Layout1MapOutline,
    [WorkspaceLayout.dualVertical]: Layout2MapsHorizontalOutline,
    [WorkspaceLayout.dualHorizontal]: Layout2MapsVerticalOutline,
    [WorkspaceLayout.triVertical]: Layout3MapsRightSplitOutline,
    [WorkspaceLayout.triHorizontal]: Layout3MapsBottomSplitOutline,
    [WorkspaceLayout.quad]: Layout4MapsOutline
};

export function WorkspacesLayoutToolbarItem() {
    const workspaceLayout = useAppSelector((x) => x.workspace.layout);
    const dispatch = useAppDispatch();

    return (
        <div id="workspace-layout-toolbar-btn" className="d-flex">
            <CustomPopover
                title="Map layout"
                trigger={
                    <Button
                        className="k-rounded-full"
                        data-tooltip-bottom
                        style={{ width: 27, height: 27 }}
                        svgIcon={workspaceLayoutToIconMap[workspaceLayout]}
                    />
                }>
                <div className="d-flex flex-column gap-0" style={{ fontSize: 12 }}>
                    {Object.entries(workspaceLayoutToIconMap).map(([layout, icon]) => (
                        <div
                            className={clsx(
                                'p-1 clickable',
                                workspaceLayout === (Number(layout) as WorkspaceLayout) && 'bg-primary bg-opacity-25'
                            )}
                            key={layout}>
                            <SvgIcon
                                key={layout}
                                icon={icon}
                                style={{ width: 20, height: 20, cursor: 'pointer' }}
                                onClick={async () => await dispatch(setWorkspaceLayout(Number(layout) as WorkspaceLayout)).unwrap()}
                            />
                        </div>
                    ))}
                </div>
            </CustomPopover>
        </div>
    );
}
